export default "__VITE_ASSET__Clb77n5z__"